class LinkedProducts extends HTMLElement {
  constructor() {
    super();

    this.onImageSwatchMouseEnterBound = this.onImageSwatchMouseEnter.bind(this);
    this.onImageSwatchMouseLeaveBound = this.onImageSwatchMouseLeave.bind(this);
    this.onImageSwatchClickBound = this.onImageSwatchClick.bind(this);
  }

  connectedCallback() {
    this.imageSwatchLabel = this.querySelector('.linked-products--title-wrapper .linked-option-product-title');
    this.imageSwatches = this.querySelectorAll('.swatch-element.image-swatch');

    this.setEventListeners();
    this.setActiveImageSwatchLabel();
  }

  setActiveImageSwatchLabel() {
    const selectedImageSwatch = this.querySelector('.swatch-element.image-swatch.active');
    if (!selectedImageSwatch) return;
    this.updateSwatchLabel(selectedImageSwatch);
  }

  updateSwatchLabel(swatch) {
    if (!swatch) return;
    const label = swatch.getAttribute('data-value');
    if (!label || !this.imageSwatchLabel) return;

    this.imageSwatchLabel.textContent = label;
    this.imageSwatchLabel.classList.remove('fade-in-label');
    void this.imageSwatchLabel.offsetWidth; // Force reflow to restart animation
    this.imageSwatchLabel.classList.add('fade-in-label');
  }

  setEventListeners() {
    if (!this.imageSwatches.length) return;

    this.imageSwatches.forEach(swatch => {
      swatch.addEventListener('mouseenter', this.onImageSwatchMouseEnterBound);
      swatch.addEventListener('mouseleave', this.onImageSwatchMouseLeaveBound);
      swatch.addEventListener('click', this.onImageSwatchClickBound);
    });
  }

  onImageSwatchMouseEnter(event) {
    const imageSwatchElement = event.currentTarget;
    this.updateSwatchLabel(imageSwatchElement);
  }

  onImageSwatchMouseLeave() {
    const activeImageSwatch = this.querySelector('.swatch-element.image-swatch.active');
    if (activeImageSwatch) {
      this.updateSwatchLabel(activeImageSwatch);
    } else if (this.imageSwatchLabel) {
      this.imageSwatchLabel.textContent = '';
    }
  }

  onImageSwatchClick(event) {
    const swatch = event.currentTarget;
    const redirectUrl = swatch.getAttribute('data-variation-redirect');

    if (redirectUrl && redirectUrl.trim() !== '') {
      window.location.href = redirectUrl;
    }
  }

  removeEventListeners() {
    this.imageSwatches.forEach(swatch => {
      swatch.removeEventListener('mouseenter', this.onImageSwatchMouseEnterBound);
      swatch.removeEventListener('mouseleave', this.onImageSwatchMouseLeaveBound);
      swatch.removeEventListener('click', this.onImageSwatchClickBound);
    });
  }

  disconnectedCallback() {
    this.removeEventListeners();
  }
}

if (!window.customElements.get('linked-products')) {
  window.customElements.define('linked-products', LinkedProducts);
}

document.addEventListener('DOMContentLoaded', () => {
  const lazySwatches = document.querySelectorAll('.lazy-swatch');

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const img = el.getAttribute('data-bg-img');
          if (img) {
            el.style.backgroundImage = `url(${img})`;
            el.style.backgroundSize = 'cover';
            el.style.backgroundPosition = 'center center';
            el.removeAttribute('data-bg-img');
          }
          obs.unobserve(el);
        }
      });
    }, { rootMargin: '50px' });

    lazySwatches.forEach(el => observer.observe(el));
  } else {
    // fallback for old browsers
    lazySwatches.forEach(el => {
      const img = el.getAttribute('data-bg-img');
      if (img) el.style.backgroundImage = `url(${img})`;
    });
  }
});
